import { Result } from 'antd-mobile';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import './App.css';
import Loading from './pages/components/Loading'
import QuestionnaireContainer from './pages/components/QuestionnaireContainer'
import EnrollContainer from './pages/enroll/components/EnrollContainer'
import { SmileOutline } from 'antd-mobile-icons'

const Questionnaire = React.lazy(() => import("./pages/Questionnaire"));
const QuestionnaireResult = React.lazy(() => import("./pages/Questionnaire/Result"));
const Privacy = React.lazy(() => import("./pages/Privacy"));
const Terms = React.lazy(() => import("./pages/Terms"));
const Signature = React.lazy(() => import("./pages/Signature"));
const SignatureResult = React.lazy(() => import("./pages/Signature/Result"));
const SignPoliceView = React.lazy(() => import("./pages/SignAuxiliaryPolice"));
const SignPoliceResultView = React.lazy(() => import("./pages/SignAuxiliaryPolice/Result"));
const SignETpa = React.lazy(() => import("./pages/SignETpa"));
const SignETpaResult = React.lazy(() => import("./pages/SignETpa/Result"))
const SignETpar = React.lazy(() => import("./pages/SignETpar"));
const SignETparResult = React.lazy(() => import("./pages/SignETpar/Result"));
const SignTpa = React.lazy(() => import("./pages/SignTpa"));
const SignTpar = React.lazy(() => import("./pages/SignTpar"));
const SignTpaResult = React.lazy(() => import("./pages/SignTpa/Result"));
const SignTparResult = React.lazy(() => import("./pages/SignTpar/Result"));
const SignTpaAction = React.lazy(() => import("./pages/SignTpa/SignAction"));
const SignTparAction = React.lazy(() => import("./pages/SignTpar/SignAction"));
const Enroll = React.lazy(() => import("./pages/enroll"));
const SignSREView = React.lazy(() => import("./pages/SpecialRecruitEnroll"));
const SignSREResult = React.lazy(() => import("./pages/SpecialRecruitEnroll/Result"));
const SignSREAction = React.lazy(() => import("./pages/SpecialRecruitEnroll/SignAction"));

const SignStudentView = React.lazy(() => import("./pages/StudentSign"));
const SignStudentResult = React.lazy(() => import("./pages/StudentSign/Result"));
const SignStudentAction = React.lazy(() => import("./pages/StudentSign/SignAction"));
function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Loading />} />

        {/* 问卷调查 */}
        <Route path='questionnaire' element={<><Outlet /></>}  >

          <Route path=":shareCode" element={<React.Suspense fallback={<Loading />}>
            <QuestionnaireContainer >
              <Questionnaire />
            </QuestionnaireContainer>
          </React.Suspense>} />

          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><QuestionnaireResult /></React.Suspense>} />


        </Route>

        <Route path='enroll' element={<><Outlet /></>}  >

          <Route path=":collegeId" element={<React.Suspense fallback={<Loading />}>
            <EnrollContainer >
              <Enroll />
            </EnrollContainer>
          </React.Suspense>} />

          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><QuestionnaireResult /></React.Suspense>} />


        </Route>

        <Route path="privacy" element={<React.Suspense fallback={<Loading />}><Privacy /></React.Suspense>} />
        <Route path="terms" element={<React.Suspense fallback={<Loading />}><Terms /></React.Suspense>} />
        <Route path="signature" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><Signature /></React.Suspense>} />
          <Route path=":token/:userId" element={<React.Suspense fallback={<Loading />}><Signature /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignatureResult /></React.Suspense>} />
        </Route>
        <Route path="signPolice" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignPoliceView /></React.Suspense>} />
          <Route path=":token/:policeId" element={<React.Suspense fallback={<Loading />}><SignPoliceView /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignPoliceResultView /></React.Suspense>} />
        </Route>
        <Route path="signETpa" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignETpa /></React.Suspense>} />
          <Route path=":token/:tpaid/:willingnessId" element={<React.Suspense fallback={<Loading />}><SignETpa /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignETpaResult /></React.Suspense>} />
        </Route>
        <Route path="signETpar" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignETpar /></React.Suspense>} />
          <Route path=":token/:tparid/:willingnessId" element={<React.Suspense fallback={<Loading />}><SignETpar /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignETparResult /></React.Suspense>} />
        </Route>
        <Route path="signTpa" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignTpa /></React.Suspense>} />
          <Route path=":token/:tpaid" element={<React.Suspense fallback={<Loading />}><SignTpa /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignTpaResult /></React.Suspense>} />
          <Route path="signAction/:id" element={<React.Suspense fallback={<Loading />}><SignTpaAction /></React.Suspense>} />
        </Route>
        <Route path="signTpar" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignTpar /></React.Suspense>} />
          <Route path=":token/:tparid" element={<React.Suspense fallback={<Loading />}><SignTpar /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignTparResult /></React.Suspense>} />
          <Route path="signAction/:id" element={<React.Suspense fallback={<Loading />}><SignTparAction /></React.Suspense>} />
        </Route>
        <Route path="signSre" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignSREView /></React.Suspense>} />
          <Route path=":token/:signid" element={<React.Suspense fallback={<Loading />}><SignSREView /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignSREResult /></React.Suspense>} />
          <Route path="signAction/:id" element={<React.Suspense fallback={<Loading />}><SignSREAction /></React.Suspense>} />
        </Route>

        <Route path="signStudent" element={<><Outlet /></>} >
          <Route path=":token" element={<React.Suspense fallback={<Loading />}><SignStudentView /></React.Suspense>} />
          <Route path=":token/:signid" element={<React.Suspense fallback={<Loading />}><SignStudentView /></React.Suspense>} />
          <Route path="result/:id" element={<React.Suspense fallback={<Loading />}><SignStudentResult /></React.Suspense>} />
          <Route path="signAction/:id" element={<React.Suspense fallback={<Loading />}><SignStudentAction /></React.Suspense>} />
        </Route>
        <Route path="*" element={<Result
          icon={<SmileOutline />}
          status='success'
          title='404'
          description='找不到页面'
        />} />
      </Routes>
    </Router>
  )
}

export default App;
